import React from 'react';
import ManagementMakeupRequests from '../../modules/makeup/ManagementMakeupRequests';

const ManagementMakeupRequestsPage = () => {
  return (
    <div className='container-fluid'>
      <ManagementMakeupRequests />
    </div>
  );
};

export default ManagementMakeupRequestsPage;
